module.exports = __webpack_public_path__ + "static/media/Map_point.e05c4a08.obj";